'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = undefined;

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _class, _temp2;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _Day = require('./Day');

var _Day2 = _interopRequireDefault(_Day);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// import numeral from 'numeral';
// import moment from 'moment';
// import { Link } from 'react-router';
// import { getColorRatingCode, getAvatar, renderTime, getUrlImage } from 'helpers/lib';
var WeeklyDayPicker = (_temp2 = _class = function (_Component) {
  (0, _inherits3.default)(WeeklyDayPicker, _Component);

  function WeeklyDayPicker() {
    var _ref;

    var _temp, _this, _ret;

    (0, _classCallCheck3.default)(this, WeeklyDayPicker);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = (0, _possibleConstructorReturn3.default)(this, (_ref = WeeklyDayPicker.__proto__ || (0, _getPrototypeOf2.default)(WeeklyDayPicker)).call.apply(_ref, [this].concat(args))), _this), _this.state = {
      firstTime: true
    }, _temp), (0, _possibleConstructorReturn3.default)(_this, _ret);
  }

  (0, _createClass3.default)(WeeklyDayPicker, [{
    key: 'selectDay',
    value: function selectDay(data) {
      this.props.onChange(data);
    }
  }, {
    key: 'title',
    value: function title(date) {
      if (!date) return '';
      var _d = new Date();
      return 'TH\xC1NG ' + (_d.getMonth() + 1) + '/' + _d.getFullYear();
    }
    // componentWillReceiveProps(nextProps) {
    //   const { selected, week } = nextProps.data;
    //   if (week && this.state.firstTime) {
    //     let data = {};
    //     for (let i = 0; i < week.length; i++) {
    //       if (week[i].empty !== 0) {
    //         data = {
    //           ...week[i],
    //           selected: selected ? selected.date : null,
    //         };
    //         this.setState({ firstTime: false });
    //         this.selectDay(data);
    //         break;
    //       }
    //     }
    //   }
    // }

  }, {
    key: 'renderDay',
    value: function renderDay(item, i) {
      var _this2 = this;

      var selected = this.props.data.selected;

      var data = (0, _extends3.default)({}, item, {
        selected: selected ? selected.date : null
      });
      return _react2.default.createElement(_Day2.default, { key: 'day_' + i, data: data, onClick: function onClick() {
          return _this2.selectDay(data);
        } });
    }
  }, {
    key: 'render',
    value: function render() {
      var _this3 = this;

      var styles = require('./WeeklyDayPicker.scss');
      var _props = this.props,
          _props$data = _props.data,
          week = _props$data.week,
          weekUI = _props$data.weekUI,
          onNext = _props.onNext,
          onPrevious = _props.onPrevious;

      if (week !== null) {
        return _react2.default.createElement(
          'div',
          { className: styles.calendar + ' ' + styles.padder },
          _react2.default.createElement(
            'div',
            { className: styles.head },
            weekUI.btnPrevious ? _react2.default.createElement(
              'div',
              { className: styles.back, onClick: onPrevious },
              _react2.default.createElement('i', { className: 'fa fa-angle-left' })
            ) : _react2.default.createElement(
              'div',
              { className: styles.back + ' ' + styles.disable },
              ' ',
              _react2.default.createElement('i', { className: 'fa fa-angle-left' }),
              ' '
            ),
            _react2.default.createElement(
              'div',
              { className: styles.title },
              this.title(week[0] ? week[0].date : '')
            ),
            weekUI.btnNext ? _react2.default.createElement(
              'div',
              { className: styles.next, onClick: onNext },
              _react2.default.createElement('i', { className: 'fa fa-angle-right' })
            ) : _react2.default.createElement(
              'div',
              { className: styles.next + ' ' + styles.disable },
              ' ',
              _react2.default.createElement('i', { className: 'fa fa-angle-right' }),
              ' '
            )
          ),
          _react2.default.createElement(
            'div',
            { className: styles.body },
            week && week.map(function (v, i) {
              return _this3.renderDay(v, i);
            })
          )
        );
      }
      return _react2.default.createElement('div', { classsName: styles.calendar });
    }
  }]);
  return WeeklyDayPicker;
}(_react.Component), _class.propTypes = {
  // @action
  onNext: _react.PropTypes.func,
  onPrevious: _react.PropTypes.func,
  onChange: _react.PropTypes.func,
  // @data
  data: _react.PropTypes.object
}, _temp2);
exports.default = WeeklyDayPicker;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/Mobile/Common/Booking/WeeklyDayPicker.js
// module id = 1573
// module chunks = 0